export default __webpack_public_path__ + "static/media/page.7ea5acf4.gif";